import McTable from './components/McTable'
import McDialog from './components/McDialog'
import McPager from './components/McPager'
import McToTop from './components/McToTop'
import McSearchBar from './components/McSearchBar'
import McLabel from './components/McLabel'

import McLayoutRow from './components/McLayoutRow';
import McOperateBar from './components/McOperateBar';
import TestSearchBar from './components/TestSearchBar'
import McSearchBarByTime from './components/McSearchBarByTime'

const components = [
    McTable,
    McDialog,
    McPager,
    McToTop,
    McLayoutRow,
    McOperateBar,
    TestSearchBar,
    McSearchBar,
    McSearchBarByTime,
    McLabel
]

const install = function(Vue){
    components.map(component => {
        Vue.component(component.name, component);
    });
}

export default {
    install
}